export function truncateText(text: string, length: number = 100) {
    if (text.length <= length) {
        return text;
    }
    return text.slice(0, length - 1) + '...';
}

export function capitalizeFirstLetter(text: string): string {
    return text.length > 0 ? text.charAt(0).toUpperCase() + text.slice(1) : text;
}
